/* unplugin-vue-components disabled */import script from "./SidebarLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=75767d11&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75767d11"]])

export default __exports__